import { Camera, SignOut, UploadSimple, User, X } from '@phosphor-icons/react'
import React, { useEffect, useState } from 'react'
import PrevixLogo from '../../assets/images/PrevixLogo.svg'
import { useAuth } from '../../context/authProvider'
import api from '../../services/api'
import { socket } from '../../services/socketApi'
import { Modal } from '../Modal'
import { Button } from '../common/Button'
import { Input } from '../common/Input'
import { SidebarData } from './SidebarData'
import { SubMenu } from './SubItem'
import {
  InputFileContainer,
  LogOffButton,
  Logo,
  Menu,
  Overlay,
  PerfilBody,
  PerfilContainer,
  PerfilHeader,
  PerfilItem,
  PerfilTab,
  PerfilUserPhoto,
  PlaceHolderFile,
  SidebarLabel,
  SidebarNav,
  SidebarWrap,
  Title,
  UserInfos,
} from './styled'

export const Sidebar = () => {
  const [userData, setUserData] = useState({
    id: '',
    login: '',
    role: '',
    UserInfo: [{ name: '', email: '', phone: '', avatar: '' }],
  })

  const { logout } = useAuth()

  const [userPhoto, setUserPhoto] = useState()
  const [userPhotoInterm, setUserPhotoInterm] = useState(undefined)
  const [fileName, setFileName] = useState('Upload de foto')

  const [isPerfilOpen, setIsPerfilOpen] = useState(false)
  const [perfilEditAvailable, setPerfilEditAvailable] = useState(false)

  const [modalUpdateConfirm, setModalUpdateConfirm] = useState(false)
  const [modalUpdateSuccess, setModalUpdateSuccess] = useState(false)
  const [modalUpdatePhotoConfirm, setModalUpdatePhotoConfirm] = useState(false)
  const [modalUploadPhoto, setModalUploadPhoto] = useState(false)
  const [modalUpdatePhotoSuccess, setModalUpdatePhotoSuccess] = useState(false)

  const handleLogout = () => {
    socket.disconnect()
    logout()
  }

  const toggleFunction = (setValue) => {
    setValue((prev) => !prev)
  }

  const handleFileChange = (event) => {
    const fileInput = event.target
    if (fileInput.files.length > 0) {
      setFileName(fileInput.files[0].name)
    } else {
      setFileName('Upload de foto')
    }
  }

  const handleEditUserData = (field, value) => {
    setUserData((prevItem) => {
      const updatedUserInfo = [...prevItem.UserInfo]
      updatedUserInfo[0] = {
        ...updatedUserInfo[0],
        [field]: value,
      }

      return {
        ...prevItem,
        UserInfo: updatedUserInfo,
      }
    })
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    handleEditUserData(name, value)
  }
  useEffect(() => {
    try {
      const userId = localStorage.getItem('id_user')
      api
        .post('/v1/user/find', { id: userId })
        .then((res) => {
          // console.log(res.data)
          setUserData(res.data)
          setUserPhoto(res.data.UserInfo[0].avatar)
        })
        .catch((err) => {
          console.log(err)
        })
    } catch (error) {
      console.log(error)
    }
  }, [])

  const saveEditUser = (type: string) => {
    try {
      const newFormData = new FormData()
      newFormData.append('id', userData.id)
      newFormData.append('login', userData.login)

      if (userPhoto) {
        newFormData.append('avatar', userPhoto)
      }
      const UserInfo = {
        name: userData.UserInfo[0].name,
        email: userData.UserInfo[0].email,
        phone: userData.UserInfo[0].phone.replace(/\D/g, ''),
      }

      newFormData.append('UserInfo', JSON.stringify(UserInfo))

      api
        .put('/v1/user/update', newFormData)
        .then((res) => {
          type === 'photo'
            ? toggleFunction(setModalUpdatePhotoSuccess)
            : toggleFunction(setModalUpdateSuccess)
          // setUserPhotoInterm(undefined)
        })
        .catch((err) => {
          console.log(err)
        })
    } catch (error) {
      console.log(error)
    }
  }

  // const removeCountryCode = () => {
  //   const number = userData.UserInfo[0].phone
  //   if (
  //     number.length > 11 &&
  //     userData.UserInfo[0].phone.substring(0, 2) === '55'
  //   ) {
  //     const result = userData.UserInfo[0].phone.slice(2)

  //     return result
  //   }
  //   return number
  // }

  const removeCountryCode = () => {
    const number = userData.UserInfo[0].phone

    if (number.startsWith('55') && number.length > 11) {
      // console.log(
      //   '🚀 ~ removeCountryCode ~  number.substring(2):',
      //   number.substring(2),
      // )
      return number.substring(2)
    }

    return number
  }

  return (
    <>
      <SidebarNav>
        <SidebarWrap>
          {/* <NavIcon to=""></NavIcon> */}
          <div>
            <Menu>
              <Logo>
                <img src={PrevixLogo} alt="Logo" />
              </Logo>
              <Title>Menu</Title>
              {SidebarData.map((item, index) => {
                return <SubMenu item={item} key={index} />
              })}
            </Menu>
            <UserInfos>
              <Title>Conta</Title>
              <PerfilItem
                onClick={() => {
                  toggleFunction(setIsPerfilOpen)
                  setPerfilEditAvailable(false)
                }}
              >
                <User size={32} color="#494949" />
                <SidebarLabel>Perfil</SidebarLabel>
              </PerfilItem>
              {/* {SidebarUserInfos.map((item, index) => {
                return <SubMenu item={item} key={index} />
              })} */}
              <div className="logOff">
                <LogOffButton onClick={handleLogout}>
                  <SignOut size={32} color="#BB0000" />
                  <span>Log Off</span>
                </LogOffButton>
              </div>
            </UserInfos>
          </div>
        </SidebarWrap>
        <PerfilTab isOpen={isPerfilOpen}>
          <PerfilContainer>
            <PerfilHeader>
              Seu perfil
              <span
                onClick={() => {
                  toggleFunction(setIsPerfilOpen)
                  setPerfilEditAvailable(false)
                }}
              >
                <X size={32} color="#003E5F" />
              </span>
            </PerfilHeader>
            <PerfilBody>
              <PerfilUserPhoto>
                <img
                  src={
                    userPhotoInterm ||
                    userPhoto ||
                    'https://via.placeholder.com/170'
                  }
                  alt=""
                />
                {perfilEditAvailable ? (
                  <div
                    onClick={() => toggleFunction(setModalUpdatePhotoConfirm)}
                  >
                    <Camera color="#494949" size={30} weight="fill" />
                  </div>
                ) : null}
              </PerfilUserPhoto>
              <Input.Root>
                <Input.Label title="Nome do usuário" htmlFor="perfilUserName" />
                <Input.Wrapper>
                  <Input.Content
                    id="perfilUserName"
                    name="name"
                    value={userData.UserInfo[0].name || ''}
                    onChange={handleChange}
                    readOnly={!perfilEditAvailable}
                  />
                </Input.Wrapper>
              </Input.Root>
              <Input.Root>
                <Input.Label
                  title="Função do usuário"
                  htmlFor="perfilUserFunction"
                />
                <Input.Wrapper>
                  <Input.Content
                    id="perfilUserFunction"
                    name="role"
                    value={userData.role}
                    readOnly={!perfilEditAvailable}
                    disabled={perfilEditAvailable}
                  />
                </Input.Wrapper>
              </Input.Root>
              <Input.Root>
                <Input.Label
                  title="Telefone de contato"
                  htmlFor="perfilUserPhone"
                />
                <Input.Wrapper>
                  <Input.Content
                    id="perfilUserPhone"
                    type="tel"
                    name="phone"
                    onChange={handleChange}
                    value={removeCountryCode().replace(
                      /^(\d{2})(\d{5})/,
                      '($1) $2-',
                    )}
                    maxLength={15}
                    // mask="telNumber"
                    // pattern="(\(\d{2}\)\s?\d{5}-\d{4})"
                    readOnly={!perfilEditAvailable}
                  />
                </Input.Wrapper>
              </Input.Root>
              <Input.Root>
                <Input.Label title="E-mail" htmlFor="perfilUserEmail" />
                <Input.Wrapper>
                  <Input.Content
                    id="perfilUserEmail"
                    type="email"
                    name="email"
                    onChange={handleChange}
                    value={userData.UserInfo[0].email}
                    readOnly={!perfilEditAvailable}
                  />
                </Input.Wrapper>
              </Input.Root>
              {perfilEditAvailable ? (
                <Button.Root
                  type="button"
                  backgroundColor="#006598"
                  onClick={() => toggleFunction(setModalUpdateConfirm)}
                >
                  <Button.Content title="Salvar dados" />
                </Button.Root>
              ) : (
                <Button.Root
                  type="button"
                  backgroundColor="#006598"
                  onClick={() => toggleFunction(setPerfilEditAvailable)}
                >
                  <Button.Content title="Editar informações" />
                </Button.Root>
              )}
            </PerfilBody>
          </PerfilContainer>
        </PerfilTab>
      </SidebarNav>

      {/* Update confirmation modal */}
      <Modal.Root
        backgroundcolor="#fff"
        borderradius="6px"
        width="fit-content"
        height="fit-content"
        left="50%"
        top="50%"
        open={modalUpdateConfirm}
        setIsOpenController={() => toggleFunction(setModalUpdateConfirm)}
        padding="0 1rem 1rem 1rem"
      >
        <Modal.Header onclick={() => toggleFunction(setModalUpdateConfirm)} />
        <Modal.Content
          value="Você deseja atualizar seus dados?"
          subvalue="Ao selecionar salvar, você atualizará seus dados."
        />
        <Modal.Footer>
          <Button.Root
            backgroundColor="#fff"
            border="1px solid #770A00"
            onClick={() => {
              toggleFunction(setPerfilEditAvailable)
              toggleFunction(setModalUpdateConfirm)
            }}
          >
            <Button.Content title="Não, cancelar" color="#770A00" />
          </Button.Root>
          <Button.Root
            backgroundColor="#00517D"
            onClick={() => {
              saveEditUser('userData')
              toggleFunction(setModalUpdateConfirm)
              // toggleFunction(setModalUpdateSuccess)
            }}
          >
            <Button.Content title="Salvar" color="#fff" />
          </Button.Root>
        </Modal.Footer>
      </Modal.Root>

      {/* Update success modal */}
      <Modal.Root
        backgroundcolor="#fff"
        borderradius="6px"
        width="fit-content"
        height="fit-content"
        left="50%"
        top="50%"
        open={modalUpdateSuccess}
        setIsOpenController={() => toggleFunction(setModalUpdateSuccess)}
        padding="0 1rem 1rem 1rem"
      >
        <Modal.Header onclick={() => toggleFunction(setModalUpdateSuccess)} />
        <Modal.Content
          value="Informações salvas!"
          subvalue="Ao acessar seu perfil, você já visualizará 
          suas informações."
        />
        <Modal.Footer>
          <Button.Root
            backgroundColor="#308EC6"
            onClick={() => {
              toggleFunction(setPerfilEditAvailable)
              toggleFunction(setModalUpdateSuccess)
            }}
          >
            <Button.Content title="OK" color="#fff" />
          </Button.Root>
        </Modal.Footer>
      </Modal.Root>

      {/* Update photo confirmation modal */}
      <Modal.Root
        backgroundcolor="#fff"
        borderradius="6px"
        width="30rem"
        height="fit-content"
        left="50%"
        top="50%"
        open={modalUpdatePhotoConfirm}
        setIsOpenController={() => toggleFunction(setModalUpdatePhotoConfirm)}
        padding="0 1rem 1rem 1rem"
      >
        <Modal.Header
          onclick={() => toggleFunction(setModalUpdatePhotoConfirm)}
        />
        <Modal.Content
          value="Você deseja atualizar sua foto?"
          subvalue="Ao clicar em upload, você seleciona uma
          foto para colocar em seu perfil."
        />
        <Modal.Footer>
          <Button.Root
            backgroundColor="#fff"
            border="1px solid #770A00"
            onClick={() => toggleFunction(setModalUpdatePhotoConfirm)}
          >
            <Button.Content title="Não, cancelar" color="#770A00" />
          </Button.Root>
          <Button.Root
            backgroundColor="#00517D"
            onClick={() => {
              toggleFunction(setModalUpdatePhotoConfirm)
              toggleFunction(setModalUploadPhoto)
            }}
          >
            <Button.Content title="Upload" color="#fff" />
          </Button.Root>
        </Modal.Footer>
      </Modal.Root>

      {/* Upload photo modal */}
      <Modal.Root
        backgroundcolor="#fff"
        borderradius="6px"
        width="30rem"
        height="fit-content"
        left="50%"
        top="50%"
        open={modalUploadPhoto}
        setIsOpenController={() => toggleFunction(setModalUploadPhoto)}
        padding="0 1rem 1rem 1rem"
      >
        <Modal.Header onclick={() => toggleFunction(setModalUploadPhoto)} />
        <Modal.Content
          value="Você deseja realmente enviar o alerta?"
          subvalue="Para selecionar uma nova foto, clique no campo de upload abaixo. Caso contrário, pode salvar."
        />
        <InputFileContainer>
          <Input.Root>
            <Input.Wrapper borderColor="#003E5F" backgroundColor="#fff">
              <PlaceHolderFile>{fileName}</PlaceHolderFile>
              <Input.Content
                id="perfilUserPhoto"
                type="file"
                onChange={(e) => {
                  handleFileChange(e)
                  setUserPhoto(e.target.files[0])
                  const reader = new FileReader()
                  reader.onload = (ev) => {
                    setUserPhotoInterm(ev.target.result)
                  }

                  if (e.target.files[0]) {
                    reader.readAsDataURL(e.target.files[0])
                  }
                }}
              />
              <Input.Icon>
                <UploadSimple size={24} color="#003E5F" />
              </Input.Icon>
            </Input.Wrapper>
          </Input.Root>
        </InputFileContainer>
        <Modal.Footer>
          <Button.Root
            backgroundColor="#fff"
            border="1px solid #770A00"
            onClick={() => toggleFunction(setModalUploadPhoto)}
          >
            <Button.Content title="Não, cancelar" color="#770A00" />
          </Button.Root>
          <Button.Root
            backgroundColor="#00517D"
            onClick={() => {
              saveEditUser('photo')
              toggleFunction(setModalUploadPhoto)
            }}
          >
            <Button.Content title="Salvar" color="#fff" />
          </Button.Root>
        </Modal.Footer>
      </Modal.Root>

      {/* Update photo success modal */}
      <Modal.Root
        backgroundcolor="#fff"
        borderradius="6px"
        width="fit-content"
        height="fit-content"
        left="50%"
        top="50%"
        open={modalUpdatePhotoSuccess}
        setIsOpenController={() => toggleFunction(setModalUpdatePhotoSuccess)}
        padding="0 1rem 1rem 1rem"
      >
        <Modal.Header
          onclick={() => toggleFunction(setModalUpdatePhotoSuccess)}
        />
        <Modal.Content
          value="Foto salva!"
          subvalue="Ao acessar seu perfil, você já visualizará 
          sua foto atualizada."
        />
        <Modal.Footer>
          <Button.Root
            backgroundColor="#308EC6"
            onClick={() => toggleFunction(setModalUpdatePhotoSuccess)}
          >
            <Button.Content title="OK" color="#fff" />
          </Button.Root>
        </Modal.Footer>
      </Modal.Root>

      <Overlay
        isOpen={isPerfilOpen}
        onClick={() => {
          toggleFunction(setIsPerfilOpen)
          setPerfilEditAvailable(false)
        }}
      />
    </>
  )
}
